const types = {
	//Get Template name
	GET_RECURRING_SURVEY_START: "GET_RECURRING_SURVEY_START",
	GET_RECURRING_SURVEY_SUCCESS: "GET_RECURRING_SURVEY_SUCCESS",
	GET_RECURRING_SURVEY_ERROR: "GET_RECURRING_SURVEY_ERROR",
	GET_RECURRING_SURVEY_RESET: "GET_RECURRING_SURVEY_RESET",

	//Create Template name
	CREATE_RECURRING_SURVEY_START: "CREATE_RECURRING_SURVEY_START",
	CREATE_RECURRING_SURVEY_SUCCESS: "CREATE_RECURRING_SURVEY_SUCCESS",
	CREATE_RECURRING_SURVEY_ERROR: "CREATE_RECURRING_SURVEY_ERROR",
	CREATE_RECURRING_SURVEY_RESET: "CREATE_RECURRING_SURVEY_RESET",

	//delete Template name
	DELETE_RECURRING_SURVEY_START: "DELETE_RECURRING_SURVEY_START",
	DELETE_RECURRING_SURVEY_SUCCESS: "DELETE_RECURRING_SURVEY_SUCCESS",
	DELETE_RECURRING_SURVEY_ERROR: "DELETE_RECURRING_SURVEY_ERROR",
	DELETE_RECURRING_SURVEY_RESET: "DELETE_RECURRING_SURVEY_RESET",

	//update Template name
	UPDATE_RECURRING_SURVEY_START: "UPDATE_RECURRING_SURVEY_START",
	UPDATE_RECURRING_SURVEY_SUCCESS: "UPDATE_RECURRING_SURVEY_SUCCESS",
	UPDATE_RECURRING_SURVEY_ERROR: "UPDATE_RECURRING_SURVEY_ERROR",
	UPDATE_RECURRING_SURVEY_RESET: "UPDATE_RECURRING_SURVEY_RESET",

	//single item  name
	SINGLE_RECURRING_SURVEY_START: "SINGLE_RECURRING_SURVEY_START",
	SINGLE_RECURRING_SURVEY_SUCCESS: "SINGLE_RECURRING_SURVEY_SUCCESS",
	SINGLE_RECURRING_SURVEY_ERROR: "SINGLE_RECURRING_SURVEY_ERROR",
	SINGLE_RECURRING_SURVEY_RESET: "SINGLE_RECURRING_SURVEY_RESET",
};

export default types;
